import { render, staticRenderFns } from "./BCXMessengerChatMessage.vue?vue&type=template&id=1364deb4&scoped=true"
import script from "./BCXMessengerChatMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXMessengerChatMessage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXMessengerChatMessage.vue?vue&type=style&index=0&id=1364deb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1364deb4",
  null
  
)

export default component.exports